<template>
    <div class="catalog-choice-label">
        <div
            v-if="sellerName"
            class="catalog-choice-label__seller d-flex align-center flex-wrap"
        >
            <span class="catalog-choice-label__seller-name font-weight-bold">{{
                sellerName
            }}</span>
            <v-icon
                v-if="sellerConnected"
                small
                color="primary"
                class="ml-1 catalog-choice-label__link-icon flex-shrink-0"
            >
                mdi-link
            </v-icon>
        </div>
        <div
            v-if="catalogName"
            class="catalog-choice-label__catalog"
            :class="{ 'catalog-choice-label__catalog--solo': !sellerName }"
        >
            {{ catalogName }}
        </div>
    </div>
</template>

<script>
export default {
    name: "CatalogChoiceLabel",
    props: {
        sellerName: {
            type: String,
            default: null,
        },
        catalogName: {
            type: String,
            required: true,
        },
        sellerConnected: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style scoped lang="scss">
.catalog-choice-label {
    width: 100%;
    padding: 0;
    margin: 0;
}

.catalog-choice-label__seller-name {
    font-size: 0.8125rem;
    line-height: 1.3;
}

.catalog-choice-label__link-icon {
    margin-top: -1px;
}

.catalog-choice-label__catalog {
    font-size: 0.8125rem;
    line-height: 1.3;
    font-weight: 400;
    margin-top: 2px;
    color: rgba(0, 0, 0, 0.87);
}

.catalog-choice-label__catalog--solo {
    margin-top: 0;
}

.theme--dark .catalog-choice-label__catalog {
    color: rgba(255, 255, 255, 0.87);
}
</style>
